import "./style.css";
import LicenseInfo from "./licenseInfo/LicenseInfo";
import arrow from "../../../assets/images/common/left-arrow.svg";
import UserInfo from "./userInfo/UserInfo";
import CompanyInfo from "./companyInfo/CompanyInfo";
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {InitialUser, UserDto} from "../dto/User.dto";
import axios from "axios";
import * as APIUrl from "../../../constants/ApiUrl";
import * as Query from "../../../constants/query/User.query";
import * as Routes from "../../../constants/Routes";
import {UserType} from "../constants/User.type";
import Popup from "../../common/popup/Popup";
import {PopupProps} from "../../common/popup/Popup.props";
import Toast from "../../common/toast/Toast";

export default function UserDetail() {
    const location = useLocation();
    const navigate = useNavigate();
    const [user, setUser] = useState<UserDto>(InitialUser);
    const [popup, setPopup] = useState<PopupProps | null>(null);
    const [toastMessageList, setToastMessageList] = useState<string[]>([]);
    const [thumbnailFile, setThumbnailFile] = useState<File | null>(null);
    const [isChangedToBasicImage, setIsChangedToBasicImage] = useState<boolean>(false);

    useEffect((): void => {
        axios.post(APIUrl.GRAPHQL, {query: Query.GET_USER(location.state.seq)}).then(
            response => {
                setUser(response.data.data.getUser);
            }
        ).catch(error => console.log(error));
    }, [location.state.seq]);

    const checkValid = (): void => {
        if (user.name === "") {
            showSimplePopup("이름을 입력해주세요.");
            return;
        }

        if (user.type === UserType.BUSINESS) {
            if (user.companyName === "") {
                showSimplePopup("회사명을 입력해주세요.");
                return;
            }

            if (user.businessNumber === "") {
                showSimplePopup("사업자번호를 입력해주세요.");
                return;
            }

            const businessNumberRegex = /^[0-9]{3}-[0-9]{2}-[0-9]{5}$/;

            if (!businessNumberRegex.test(user.businessNumber)) {
                showSimplePopup("사업자번호를 정확히 입력해주세요.");
                return;
            }
        }

        update();
    }

    const showSimplePopup = (message: string): void => {
        setPopup({
            subject: "사용자 상세 정보",
            message1: message,
            message2: null,
            buttonName: "확인",
            useCloseButton: false,
            onConfirm: () => setPopup(null),
            onClose: () => {}
        });
    }

    const update = (): void => {
        axios.put(APIUrl.SPECIFIC_USER(user.seq), user).then(
            () => {
                if (thumbnailFile || isChangedToBasicImage) {
                    updateThumbnail().then(() => {
                        setToastMessageList([...toastMessageList, "사용자 정보가 수정되었습니다."]);
                    }).catch(error => console.log(error));
                } else {
                    setToastMessageList([...toastMessageList, "사용자 정보가 수정되었습니다."]);
                }
            }
        ).catch(error => console.log(error));
    }

    const updateThumbnail = (): Promise<void> => {
        return axios.put(APIUrl.UPDATE_USER_THUMBNAIL, getFormData(), {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
    }

    const showDeletePopup = (): void => {
        setPopup({
            subject: "사용자 상세 정보",
            message1: "사용자를 삭제하시겠습니까?",
            message2: null,
            buttonName: "삭제",
            useCloseButton: true,
            onConfirm: () => deleteUser(),
            onClose: () => setPopup(null)
        });
    }

    const deleteUser = (): void => {
        axios.delete(APIUrl.SPECIFIC_USER(user.seq)).then(
            response => {
                navigate(Routes.USER);
            }
        ).catch(error => console.log(error));
    }

    const moveList = (): void => {
        navigate(Routes.USER);
    }

    const changeData = (key: string, value: string): void => {
        setUser({...user, ...{[key]: value}});
    }

    const changeThumbnailFile = (file: File | null): void => {
        if (file) {
            setThumbnailFile(file);
        } else {
            setIsChangedToBasicImage(true);
            setThumbnailFile(null);
        }
    }

    const getFormData = (): FormData => {
        const formData = new FormData();
        formData.append("seq", user.seq.toString());

        if (thumbnailFile) {
            formData.append("file", thumbnailFile);
        }

        return formData;
    }

    const closeToast = (): void => {
        setToastMessageList(toastMessageList.splice(1));
    }

    return (
        <>
            <div className="member-buisness-detail">
                <div className="wrapper">
                    <div className="member-manager-detail-body">
                        <div className="member-detail-title">
                            <div className="left">
                                <button onClick={() => moveList()} className="arrow">
                                    <img src={arrow} alt="arrow"/>
                                </button>
                                <div className="text">
                                    사용자상세
                                </div>
                            </div>
                            <div className="right">
                                <button onClick={() => showDeletePopup()} className="delete-button">
                                    삭제하기
                                </button>
                                <button onClick={() => checkValid()} className="save-button">
                                    변경내용 저장
                                </button>
                            </div>
                        </div>
                        <UserInfo user={user} onChangeName={changeData} onChangeThumbnailFile={changeThumbnailFile}/>
                        {user.type === UserType.BUSINESS && <CompanyInfo user={user} onChangeCompanyInfo={changeData}/>}
                        <LicenseInfo licenses={user.licenses}/>
                    </div>
                </div>
            </div>
            {popup && <Popup data={popup}/>}
            {
                toastMessageList.map((message, index) => {
                    return (
                        <Toast key={index} message={message} onClose={closeToast}/>
                    );
                })
            }
        </>
    );
}